import ErrorBoundary from '@/components/ErrorBoundary';
import { DefaultComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { ShoppableVideo, VideoShoppableProps } from './Video.Shoppable';

export interface StandaloneShoppableVideoProps extends StandaloneComponentProps {
  mediaId: VideoShoppableProps['mediaId'];
}

export const StandaloneShoppableVideo: StandaloneComponent<StandaloneShoppableVideoProps> = ({ mediaId, ...props }) => {
  return (
    <ErrorBoundary>
      <ShoppableVideo mediaId={mediaId} {...props} />
    </ErrorBoundary>
  );
};

const DefaultShoppableVideo: DefaultComponent = ({ type, meta, data, descendants }) => {
  const { videoData } = data;

  return <StandaloneShoppableVideo mediaId={videoData.videoID} {...withDebugMetadata({ type, meta })} />;
};

export const standalone = StandaloneShoppableVideo;

export default DefaultShoppableVideo;
